import { render, staticRenderFns } from "./RadioButtonGroup.vue?vue&type=template&id=523e3662"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./RadioButtonGroup.vue?vue&type=style&index=0&id=523e3662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports